import React, { useState, useCallback, useEffect } from 'react';
import Tooltip from '@amzn/meridian/tooltip';
import { ERROR_COLOR, SUCCESS_COLOR } from '@constants/values';
import Icon from '@amzn/meridian/icon';
import errorTokens from '@amzn/meridian-tokens/base/icon/alert-error-large';
import Row from '@amzn/meridian/row';
import { ICellRendererParams } from 'ag-grid-community';
import AgileUploadRow from '@components/agile/types/AgileUploadRow';
import debounce from 'lodash/debounce';
import { AgileMacroplanogram } from '@components/agile/types/AgileMacroplanogramTypes';
import arrowDownLargeTokens from '@amzn/meridian-tokens/base/icon/arrow-down-large';
import arrowUpLargeTokens from '@amzn/meridian-tokens/base/icon/arrow-up-large';
import DoubleClickInput from '../../../agGridCommonComponents/DoubleClickInput';

export const AtFohCapacityCellRenderer = (prams: {
  value: {
    capacity: number | null;
    jumbleFactor: number | null;
    errorMsg: unknown;
  };
  rowData: AgileUploadRow[];
  setRowData: (value: AgileUploadRow[]) => void;
  setDisableAdjustCapacityButton: (value: boolean) => void;
  listOfMacroplanogram: AgileMacroplanogram[] | undefined;
  node: ICellRendererParams;
}) => {
  const { node, setRowData, rowData, setDisableAdjustCapacityButton, value, listOfMacroplanogram } = prams;
  const [newCapacity, setNewCapacity] = useState(value.capacity);
  const [overRideCapacity, setOverRideCapacity] = useState(false);
  const data: AgileUploadRow = node.data as AgileUploadRow;
  if (value.errorMsg !== null) {
    setDisableAdjustCapacityButton(true);
  }
  useEffect(() => {
    const hasValidData = 'macroplanogramId' in node.data;
    if (hasValidData) {
      const macroplanogramDetails = listOfMacroplanogram?.find(
        ({ entryId: objValue }) => objValue === data.macroplanogramId,
      );
      if (macroplanogramDetails && macroplanogramDetails.isCapacityOverrideAllowed) {
        setOverRideCapacity(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.macroplanogramId]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const updateRowDataWithNewCapacity = useCallback(
    debounce((updatedCapacity: number) => {
      const tempData = [...rowData];
      const rowIndex = tempData.findIndex((item) => item.asin === data.asin);
      tempData[rowIndex].fohCapacity = {
        capacity: Math.round(updatedCapacity) || 0,
        jumbleFactor: value.jumbleFactor,
        errorMsg: null,
      };
      tempData[rowIndex].fohCapacityPerUnit = Math.round(
        (updatedCapacity == null ? 0 : updatedCapacity) / tempData[rowIndex].facingUnits,
      );
      setRowData(tempData);
    }, 100),
    [],
  );
  const handleChangedCapacity = (updatedCapacity: number) => {
    setNewCapacity(updatedCapacity);
    updateRowDataWithNewCapacity(updatedCapacity);
  };
  return (
    <div>
      {(() => {
        if (value.errorMsg) {
          return (
            <Tooltip position="end" title={value.errorMsg as string} id="myTooltip">
              <Icon className={ERROR_COLOR} tokens={errorTokens} />
            </Tooltip>
          );
        }
        if (overRideCapacity) {
          return <DoubleClickInput value={(newCapacity as number) || 1} onChange={handleChangedCapacity} />;
        }
        if (value.jumbleFactor !== null && value.jumbleFactor !== 0) {
          return (
            <Tooltip position="end" title={`Jumble Factor: ${value.jumbleFactor}%`} id="myTooltip">
              <Row>
                <span>{value.capacity as number}</span>
                {value.jumbleFactor > 0 ? (
                  <span>
                    <Icon className={ERROR_COLOR} tokens={arrowDownLargeTokens} />
                  </span>
                ) : (
                  <span>
                    <Icon className={SUCCESS_COLOR} tokens={arrowUpLargeTokens} />
                  </span>
                )}
              </Row>
            </Tooltip>
          );
        }
        return value.capacity as number;
      })()}
    </div>
  );
};
export default AtFohCapacityCellRenderer;
